import { useNavigation } from '@react-navigation/native';
import React, { useState } from 'react';
import { Platform } from 'react-native';

import { withActivityActorAsOwner } from '@components/ActivityList/activityHelpers';
import ChatImages from '@components/Chat/ChatImages';
import { Box } from '@components/Restyle';
import { Document, LocalFile, User } from '@graphql/generated';
import { usePreviewDocuments } from '@hooks/usePreviewDocuments';
import { ImagesPreview } from '@screens/Chats/ImagesPreview.web';

interface ActivityItemDocumentsProps {
  documents: Document[];
  /** The audit's actor (`audit.user`); shown as the owner in the preview. */
  actor?: User | null;
  taskId?: string;
  isActivityItem?: boolean;
  isTask?: boolean;
  isDocumentType?: boolean;
}

export const ActivityItemDocuments: React.FC<ActivityItemDocumentsProps> = ({
  documents,
  actor,
  taskId,
  isActivityItem = false,
  isTask = false,
  isDocumentType = false,
}) => {
  const { setPreviewDocuments, setActiveIndex } = usePreviewDocuments();
  const navigation = useNavigation();
  const [isImageCarouselVisible, setImageCarouselVisible] = useState(false);

  return (
    <Box>
      <ChatImages
        isActivityItem={isActivityItem}
        isTask={isTask}
        isDocumentType={isDocumentType}
        list={documents}
        onPress={(item: Document | LocalFile) => {
          const previewDocuments = withActivityActorAsOwner(documents, actor);
          if (Platform.OS === 'web') {
            setPreviewDocuments(previewDocuments);
            setActiveIndex(documents.findIndex((d) => d.id === item.id));
            setImageCarouselVisible(true);
          } else {
            const index = documents.findIndex(
              (d) => d.id === (item as Document).id
            );
            setPreviewDocuments(previewDocuments);
            setActiveIndex(index >= 0 ? index : 0);
            navigation.navigate('images-preview', {
              isFromProjectOrTask: true,
              taskId: taskId,
              deleteCall: isTask ? 'task' : 'project',
            });
          }
        }}
      />
      {Platform.OS === 'web' && isImageCarouselVisible && (
        <ImagesPreview
          supportNonImageFiles
          onDismiss={() => setImageCarouselVisible(false)}
          taskId={taskId}
        />
      )}
    </Box>
  );
};
